import React from "react";
import PPLabel from "components/common/PPLabel";

class UprName extends React.Component {
  render() {
    const { item } = this.props;

    return (
      <div className="flex items-center justify-between font-semibold text-gray-800">
        {!item.segment && !item.custom && item.uprName}
        {item.segment && (
          <div>
            <div>{item.segment.name}</div>
            <div className="text-xs font-normal text-gray-600">
              {item.uprName}
            </div>
          </div>
        )}
        {item.custom && (
          <div>
            <div>{item.custom.name}</div>
            <div className="text-xs font-normal text-gray-600">
              {item.uprName}
            </div>
          </div>
        )}
        <PPLabel item={item} isSmall={true}></PPLabel>
      </div>
    );
  }
}

export default UprName;
